import { useState, useEffect } from 'react'

/**
 * Transforms raw productOptions into desktop table-ready row data.
 * @param {Object} params
 * @param {Array} params.productOptions - Raw product options list
 * @param {Array} params.columnIdentifiers - Column label/identifier pairs
 * @param {boolean} params.isDesktop - Whether the viewport is desktop
 * @returns {{ desktopData: Array }}
 */
const useProductOptionsData = ({ productOptions, columnIdentifiers, isDesktop }) => {
    const [desktopData, setDesktopData] = useState([])

    const getIdentifierValue = (product, identifier) =>
        product?.classificationAttributes?.find(
            (attribute) => attribute.identifier === identifier
        )

    useEffect(() => {
        if (isDesktop && productOptions?.length > 0 && columnIdentifiers.length > 0) {
            const tempData = []
            productOptions.forEach((product, index) => {
                const tempObj = {}
                tempObj.column1 = product.productDetails
                columnIdentifiers.forEach((col, i) => {
                    const column = getIdentifierValue(product, col.identifier)
                    let dataValue = ''
                    if (Array.isArray(column?.values)) {
                        dataValue = column.values.join(', ')
                    }
                    tempObj[`column${i + 2}`] = dataValue
                })
                tempObj[`column${columnIdentifiers.length + 2}`] = product
                tempData.push(tempObj)
            })
            setDesktopData(tempData)
        }
    }, [productOptions, columnIdentifiers, isDesktop])

    return { desktopData }
}

export default useProductOptionsData
